import { render, staticRenderFns } from "./ModalNoticeOrganization.vue?vue&type=template&id=4ef2eb4f&scoped=true&"
import script from "./ModalNoticeOrganization.vue?vue&type=script&lang=js&"
export * from "./ModalNoticeOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ModalNoticeOrganization.vue?vue&type=style&index=0&id=4ef2eb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2eb4f",
  null
  
)

export default component.exports